var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPesticide(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 46 58",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ecf0f1",
    d: "M19 2v7H7V2a2.006 2.006 0 0 1 2-2h8a2.006 2.006 0 0 1 2 2z",
    opacity: 1,
    "data-original": "#ecf0f1",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3886ff",
    d: "m45.58 9.84-2.86-7.87A2.992 2.992 0 0 0 39.91 0H26a3 3 0 0 0-3 3v1a3 3 0 0 1-3 3H7l-5.24 5.24A5.993 5.993 0 0 0 0 16.49v29.37c.002 1.992.295 3.973.87 5.88a21.033 21.033 0 0 0 2.57 5.42c.372.531.981.846 1.63.84h3.1c.533 0 1.044-.213 1.42-.59l1-1a1.992 1.992 0 0 1 2.82 0l1 1c.376.377.887.59 1.42.59h3.34c.533 0 1.044-.213 1.42-.59l1-1a1.992 1.992 0 0 1 2.82 0l1 1c.376.377.887.59 1.42.59h3.34c.533 0 1.044-.213 1.42-.59l1-1a1.992 1.992 0 0 1 2.82 0l1 1c.376.377.887.59 1.42.59h3.1a1.981 1.981 0 0 0 1.66-.89A20.3 20.3 0 0 0 46 45.86V12.23a6.913 6.913 0 0 0-.42-2.39zM40.31 11H28a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1h10.5a.992.992 0 0 1 .94.66l1.81 5a1 1 0 0 1-.94 1.34z",
    opacity: 1,
    "data-original": "#4fba6f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0f65e9",
    d: "M35.6 19H10.4a5.016 5.016 0 0 1-3.126-1.1l-2.649-2.119a1 1 0 1 1 1.25-1.562l2.65 2.12A3 3 0 0 0 10.4 17h25.2a3 3 0 0 0 1.874-.66l2.651-2.121a1 1 0 0 1 1.25 1.562l-2.65 2.12A5.017 5.017 0 0 1 35.6 19z",
    opacity: 1,
    "data-original": "#24ae5f",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bdc3c7",
    d: "M12 0v3a1 1 0 0 1-2 0V0zM16 0v3a1 1 0 0 1-2 0V0z",
    opacity: 1,
    "data-original": "#bdc3c7",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 37,
    r: 15,
    fill: "#ffffff",
    opacity: 1,
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#464f5d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19 41h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2zM19 37h-2a1 1 0 0 1-.447-.1l-2-1a1 1 0 0 1 .894-1.79l1.789.9H19a1 1 0 0 1 0 2zM32 41h-5a1 1 0 0 1 0-2h5a1 1 0 0 1 0 2zM29 37h-2a1 1 0 0 1 0-2h1.764l1.789-.9a1 1 0 0 1 .894 1.79l-2 1A1 1 0 0 1 29 37zM31 46a1 1 0 0 1-.446-.1l-1.79-.9H27a1 1 0 0 1 0-2h2a1 1 0 0 1 .447.1l2 1A1 1 0 0 1 31 46zM15 46c.155.001.308-.033.447-.1l1.789-.9H19a1 1 0 0 0 0-2h-2a1 1 0 0 0-.447.1l-2 1A1 1 0 0 0 15 46z",
    fill: "#464f5d",
    opacity: 1,
    "data-original": "#464f5d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#5d4c72",
    d: "M27 35v9a3.992 3.992 0 0 1-3 3.87 3.911 3.911 0 0 1-2 0 4.078 4.078 0 0 1-1.83-1.04A4.025 4.025 0 0 1 19 44v-9a1.97 1.97 0 0 1 2-1.98h4A1.97 1.97 0 0 1 27 35z",
    opacity: 1,
    "data-original": "#5d4c72",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e64c3c",
    d: "M35.8 27.4a16 16 0 1 0-15.063 25.439c.762.11 1.53.164 2.3.164A16 16 0 0 0 35.8 27.4zm-21.2-1.6a13.893 13.893 0 0 1 8.371-2.8c.672 0 1.343.048 2.008.144a13.884 13.884 0 0 1 8.582 4.689L11.241 44.57C7.273 38.399 8.738 30.212 14.6 25.8zm16.8 22.4c-5.872 4.41-14.156 3.524-18.961-2.03l22.32-16.74c3.968 6.171 2.503 14.358-3.359 18.77z",
    opacity: 1,
    "data-original": "#e64c3c",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5d4c72",
    d: "M22.177 30.727a1 1 0 0 1-.546-.163l-4.178-2.727a1 1 0 0 1 1.094-1.674l4.178 2.727a1 1 0 0 1-.548 1.837z",
    opacity: 1,
    "data-original": "#5d4c72",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5d4c72",
    d: "M23.823 30.727a1 1 0 0 1-.548-1.837l4.178-2.727a1 1 0 0 1 1.094 1.674l-4.178 2.727a1 1 0 0 1-.546.163z",
    opacity: 1,
    "data-original": "#5d4c72",
    className: ""
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 23,
    cy: 31,
    r: 3,
    fill: "#7d6599",
    opacity: 1,
    "data-original": "#7d6599",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#3d324c",
    d: "M24 42v5.87a3.911 3.911 0 0 1-2 0V42a1 1 0 0 1 2 0z",
    opacity: 1,
    "data-original": "#3d324c"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPesticide);
export default __webpack_public_path__ + "static/media/pesticide.e01edb7265503c35a68ae13b966ccac6.svg";
export { ForwardRef as ReactComponent };